import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TYPE_MESSAGE_NAVIGATION, cheminInterne } from "./navigationNotification.js";

/**
 * Reçoit du service worker l'ordre de naviguer quand l'utilisateur touche une notification
 * alors que l'application est déjà ouverte (voir navigationNotification.js). À poser une
 * fois, DANS le routeur. N'affiche rien.
 */
export default function NavigationDepuisNotification() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return undefined;

    const surMessage = (evenement) => {
      const donnees = evenement.data;
      if (!donnees || donnees.type !== TYPE_MESSAGE_NAVIGATION) return;
      // Seuls les chemins internes sont suivis : jamais d'URL absolue vers un autre site.
      const chemin = cheminInterne(donnees.chemin, window.location.origin);
      if (chemin === null) return;
      navigate(chemin);
      // Accusé de réception : sans lui, le service worker croit le message perdu et
      // recharge la page à la place.
      if (evenement.ports && evenement.ports[0]) evenement.ports[0].postMessage("ok");
    };

    navigator.serviceWorker.addEventListener("message", surMessage);
    return () => navigator.serviceWorker.removeEventListener("message", surMessage);
  }, [navigate]);

  return null;
}
